import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const handleFileUpload = (selectedFile) => {
  const formData = new FormData();
  formData.append('file', selectedFile);

  return axios.post(`${API_URL}/common/secureFileUpload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const handleUploadDoc = (selectedFile) => {
  const formData = new FormData();
  formData.append('file', selectedFile);

  return axios.post(`${API_URL}/common/secureKmlUpload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default {
  handleFileUpload,
  handleUploadDoc
};
